export default __webpack_public_path__ + "static/media/menu_qr_inactive.3e206834.svg";